import { BookOpen, Compass, Clock, Heart, ArrowRight } from "lucide-react";
import { INTRO, WELCOME, SESSIES } from "@/data";
import { Reveal, LeafDivider } from "@/components/Reveal";

const ICONS = { BookOpen, Compass };

export const WelcomeSessions = () => (
  <section id="sessies" className="py-24 lg:py-28 bg-brand-cream grain">
    <div className="max-w-5xl mx-auto px-6 lg:px-10">
      <Reveal className="text-center">
        <LeafDivider label="Welkom" />
        <h2 className="font-display text-4xl sm:text-5xl text-brand-forest mt-3">{WELCOME.title}</h2>
        <p className="font-display text-2xl text-brand-sage italic max-w-3xl mx-auto mt-5 leading-snug">{INTRO}</p>
      </Reveal>

      <Reveal delay={0.1}>
        <div className="max-w-3xl mx-auto mt-10 space-y-4 font-body text-brand-ink leading-relaxed text-center">
          <p>{WELCOME.intro}</p>
          <p>{WELCOME.extra}</p>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="card-soft rounded-2xl p-7 sm:p-9 mt-12">
          <h3 className="font-display text-2xl text-brand-forest flex items-center gap-2">
            <Heart size={20} className="text-brand-gold" /> {WELCOME.begeleidingTitle}
          </h3>
          <div className="mt-4 space-y-4 font-body text-brand-ink leading-relaxed">
            {WELCOME.begeleiding.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </div>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-6 mt-8">
        {SESSIES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.id} delay={0.1 + i * 0.1}>
              <div className="card-soft rounded-2xl p-7 h-full flex flex-col" data-testid={`sessie-${s.id}`}>
                <span className="eyebrow !text-brand-gold">{s.label}</span>
                <h3 className="font-display text-2xl text-brand-forest mt-2 flex items-center gap-2">
                  <Icon size={20} className="text-brand-sage" /> {s.name}
                </h3>
                <p className="font-body text-sm text-brand-inkSoft mt-3 leading-relaxed flex-1">{s.text}</p>
                <div className="flex items-baseline gap-2 mt-5">
                  <span className="font-display text-4xl text-brand-sage">{s.price}</span>
                  <span className="font-body text-sm text-brand-inkSoft">{s.available}</span>
                </div>
                <p className="flex items-center gap-2 mt-2 font-body text-sm text-brand-sage">
                  <Clock size={15} /> Duur: {s.duration}
                </p>
                <a href="#contact" className="mt-4 inline-flex items-center gap-2 text-brand-forest font-body text-sm hover:text-brand-sage transition-colors">
                  Plan een sessie <ArrowRight size={14} />
                </a>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
